import React, { useMemo } from 'react';
import './index.h5.less';

import Icon from '@components/icon';
import { formatTime } from '@utils/i18n-locale';
import { ParamValue, goOfficial } from '@utils/nav';
import { formatNumber, isNotUndefined } from '@utils/util';

interface Action {
    icon: string;
    content: React.ReactNode;
    onClick?: () => void;
}

interface IProps {
    title: string;
    time: number;
    link: string;
    navTitle?: string;
    diggCount?: number;
    commentCount?: number;
    cover?: string;
    actions?: Action[];
    onClickCard?: () => void;
}

const Card: React.FC<IProps> = ({
    title,
    time,
    cover,
    navTitle,
    diggCount,
    commentCount,
    link,
    actions: customActions,
    onClickCard,
}) => {
    const actions = useMemo(() => {
        if (customActions) {
            return customActions;
        }
        const arr: Action[] = [];
        if (isNotUndefined(diggCount)) {
            arr.push({
                icon: 'heart',
                content: formatNumber(diggCount),
            });
        }
        if (isNotUndefined(commentCount)) {
            arr.push({
                icon: 'comment3',
                content: formatNumber(commentCount),
            });
        }
        return arr;
    }, [customActions, diggCount, commentCount]);

    return (
        <div
            className="article-card"
            onClick={() => {
                const ret = onClickCard?.();
                if (!ret) {
                    goOfficial(
                        link,
                        { title: navTitle || 'Article' },
                        {
                            hideNavigationBar: ParamValue.On,
                            hideStatusBar: ParamValue.On,
                        },
                    );
                }
            }}
        >
            <div className="article-card-top">
                <div className="article-card-title">{title}</div>
                {cover && <img className="article-card-cover" src={cover} />}
            </div>
            <div className="article-card-bottom">
                <div className="article-card-time">{formatTime(time, 'll')}</div>
                {actions?.length ? (
                    <div className="article-card-action">
                        {actions?.map(action => (
                            <div className="article-card-action-item" onClick={action.onClick}>
                                <Icon type={action.icon} />
                                <span>{action.content}</span>
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
        </div>
    );
};
export default Card;
